import { useEffect, useState } from 'react'
import useTranslation from '../../../../modules/i18n/useTranslation'
import BandBannerContainer from '../../../common/BandBannerContainer'
import HeaderNavigationBarV2 from '../header-navigation/desktop/HeaderNavigationBarV2'
import MainNav from './MainNav'
import SubNav from './SubNav'
import useLandingNav from './useLandingNav'

const LandingNav = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const { isSubNavVisible } = useLandingNav()

  const { isLocaleKO } = useTranslation()

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 58) {
        setIsScrolled(true)
      } else {
        setIsScrolled(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  if (!isLocaleKO) return <HeaderNavigationBarV2 />

  return (
    <div
      className={`sticky top-0 z-[10000] backdrop-blur-sm transform transition-transform duration-300 ease-in-out ${
        isScrolled && isSubNavVisible ? '-translate-y-56' : 'translate-y-0'
      }`}
    >
      <BandBannerContainer />
      <MainNav />
      {isSubNavVisible && <SubNav />}
    </div>
  )
}

export default LandingNav
